import { IStatsRegressionOptions, IStatsRegressionResult, TypeStatsDataPoint } from '../library/regression.interface';
import { AbstractRegressionLibrary } from '../library/regression';


/**------------------------------------------------------
 * Regressions
 */
export class StatsRegression extends AbstractRegressionLibrary {

	/**------------------------------------------------------
	 * Curve Fitting
	 */
	linearFit(dataPoints: TypeStatsDataPoint[], options?: Partial<IStatsRegressionOptions>): IStatsRegressionResult {
		return this.linear(dataPoints, options);
	}

	exponentialFit(dataPoints: TypeStatsDataPoint[], options?: Partial<IStatsRegressionOptions>): IStatsRegressionResult {
		return this.exponential(dataPoints, options);
	}

	logarithmicFit(dataPoints: TypeStatsDataPoint[], options?: Partial<IStatsRegressionOptions>): IStatsRegressionResult {
		return this.logarithmic(dataPoints, options);
	}

	powerFit(dataPoints: TypeStatsDataPoint[], options?: Partial<IStatsRegressionOptions>): IStatsRegressionResult {
		return this.power(dataPoints, options);
	}

	polynomialFit(dataPoints: TypeStatsDataPoint[], options?: Partial<IStatsRegressionOptions>): IStatsRegressionResult {
		return this.polynomial(dataPoints, options);
	}


	/**------------------------------------------------------
	 * Custom
	 */
	linearRangeFit(dataPoints: TypeStatsDataPoint[], value: number): number {

		//0 - try to find the right fit
		for (let index: number = 0; index < dataPoints.length - 1; index++) {

			//a. is it in the current range?
			const current: TypeStatsDataPoint = dataPoints[index];
			const next   : TypeStatsDataPoint = dataPoints[index + 1];
			if (value < current[0] || value > next[0]) continue;

			//b. get the y for the value, by a linear fit
			const rangeFittedValue: number = this.linearFit([current, next], { precision: 6 }).predict(value)[1];
			return rangeFittedValue;
		}

		//1 - no valid fit found
		throw new Error(`Regression => linearRangeFit => FATAL ERROR: no range fitted the data-points`);
	}
}
